export const getAttemptId = state => state.rootReducer.testPageDetails.currentAttemptId;
export const getQuestionId = state => state.rootReducer.testPageDetails.leftSectionProps.questionId;
export const getvideoId = state => state.rootReducer.testPageDetails.leftSectionProps.videoId;